<script setup lang="ts">
import { toRefs } from 'vue';
import { useField } from 'vee-validate';
import { z } from 'zod';
import { toTypedSchema } from '@vee-validate/zod';
import VDatePicker from '@shared/form/VDatePicker/VDatePicker.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';
import { tryFormatDate } from '@tools/dates';

const props = defineProps<{
  minDate: Date;
  maxDate: Date;
  isRequired?: boolean;
  disabled?: boolean;
  tooltip?: string;
}>();
const { disabled, minDate, maxDate, tooltip } = toRefs(props);

const schema = toTypedSchema(
  z.date().refine((date) => date >= minDate.value && date <= maxDate.value, {
    message: `De ingangsdatum moet tussen ${tryFormatDate(minDate.value)} en ${tryFormatDate(maxDate.value)} liggen.`,
  }),
);
const { value, errorMessage, handleBlur } = useField('ingangsdatum', schema);
</script>

<template>
  <FieldRowV2
    :errors="[errorMessage]"
    label="Ingangsdatum"
    label-for="ingangsdatum"
    label-on-own-row
    label-text-color="primary900"
    :tooltip
  >
    <VDatePicker
      id="ingangsdatum"
      v-model="value"
      @blur="handleBlur"
      :invalid="!!errorMessage"
      :clearable="false"
      :min-date
      :max-date
      :disabled
      data-testid="ingangsdatum"
    />
  </FieldRowV2>
</template>
